export const newApplicationNavigationRoutes = [
  { route: 'firm', name: 'Firm', subroute: ['main', 'practice', 'percentages', 'real-estate', 'securities-law', 'relationships', 'loss-prevention'] },
  { route: 'attorneys', name: 'Attorneys', subroute: ['main', 'about', 'relationships', 'ic-oc'] },
  { route: 'insurance', name: 'Insurance', subroute: ['last-insurances', 'past-liability', 'claims'] },
  { route: 'quote', name: 'Select Quote', subroute: ['type', 'select'] },
  { route: 'review', name: 'Review', subroute: ['firm', 'attorneys', 'insurance'] },
  { route: 'sign', name: 'Sign', subroute: ['signature', 'complete'] },
]

export const newApplicationJudgeNavigationRoutes = [
  { route: 'basic', name: 'Judge', subroute: ['main'] },
  { route: 'insurance', name: 'Insurance', subroute: ['last-insurances', 'past-liability', 'claims'] },
  { route: 'quote', name: 'Quote Details', subroute: ['details'] },
  { route: 'review', name: 'Review', subroute: ['basic', 'insurances'] },
  { route: 'sign', name: 'Sign', subroute: ['signature', 'complete'] },
]

export const renewalApplicationNavigationRoutes = [
  { route: 'firm', name: 'Firm', subroute: ['main', 'practice', 'percentages', 'real-estate', 'securities-law'] },
  { route: 'attorneys', name: 'Attorneys', subroute: ['left', 'joined', 'verify', 'sole-practitioner', 'ic-oc'] },
  { route: 'questions', name: 'Renewal Questions', subroute: ['main', 'claims'] },
  { route: 'quote', name: 'Select Quote', subroute: ['select'] },
  { route: 'review', name: 'Review', subroute: ['firm', 'attorneys', 'questions'] },
  { route: 'sign', name: 'Sign', subroute: ['signature', 'complete'] },
]

export const renewalJudgeApplicationNavigationRoutes = [
  { route: 'basic', name: 'Judge', subroute: ['main'] },
  { route: 'questions', name: 'Renewal Questions', subroute: ['main', 'claims'] },
  { route: 'quote', name: 'Quote Details', subroute: ['details'] },
  { route: 'review', name: 'Review', subroute: ['basic', 'questions'] },
  { route: 'sign', name: 'Sign', subroute: ['signature', 'complete'] },
]

export const areasOfPracticeOld = [
  'Real Estate',
  'General Business',
  'Fiduciary',
  'Securities Law',
  'Estate, Trust, and Probate',
  'Family',
  'Plaintiff Representation',
  'Other Plaintiff Representation',
  'Defense',
  'Taxation',
  'Administrative',
  'Oil & Gas',
  'Immigration',
  'Environmental',
  'Intellectual Property',
  'Other'
]

export const areasOfPractice = [
  'Real Estate',
  'General Business - Other Than Real Estate',
  'Bankruptcy',
  'Collections',
  'Securities Municipal Bonds - Tax Exempt',
  'Securities - Other Types Of Securities Practice',
  'Estate, Trust And Probate Law (Including Wills And Fiduciary)',
  'Family Law (Including Juvenile And Adoption)',
  'Plaintiff Representation',
  'Other Plaintiff Representation',
  'Defense',
  'Taxation',
  'Intellectual Property',
  'Immigration',
  'Oil And Gas (Includes Title Work)',
  'Administrative',
  'Mediation/Arbitration',
  'Environmental',
  'Other'
]

export const subareasOfPracticeOld: { [area: string]: string[] } = {
  'Real Estate': [
    'Commercial',
    'Residential',
    'Foreclosure',
    'Another kind of real estate'
  ],
  'Securities Law': [
    'Public Offering Securities',
    'Private Placement of Securities',
    'Oil and Gas Syndications',
    'Municipal Bonds - Tax Exempt - Reviewed by Attorney General',
    'Municipal Bonds - Taxable',
    'Limited Partnerships',
    'Joint Ventures (uses of contemplates using private investor funds)',
    'Other Types of Securities Practice'
  ],

  'General Business': [
    'Collections, Bankruptcy, Other Debt',
    'Business Organization Matters',
    'Business Transactions - Contracts',
    'General Business/Corporate Advice',
    'Financial Institution Representation'
  ],
  'Fiduciary': [
    'ERISA',
    'Employee Benefits',
    'Attorney/Guardian Ad Litem',
  ],
  'Estate, Trust, and Probate': [
    'Estate Administration',
    'Estate Planning',
    'Trust Administration',
    'Drafting of Wills',
    'Probate',
    'Guardianship',
  ],
  'Family': [
    'Domestic Relations - Including Divorce',
    'Juvenile Proceedings',
    'Adoption Services',
  ],
  'Plaintiff Representation': [
    'Bodily Injury or Personal Injury',
    'Workers’ Compensation',
    'Medical Malpractice',
    'Mass/Group Tort, Class Action',
  ],
  'Other Plaintiff Representation': [
    'Persons Seeking Other Affirmative Relief Under Civil Law',
    'Commercial Litigation',
  ],
  'Defense': [
    'Insurance Defense',
    'Commercial Litigation Defense',
    'Criminal Defense',
  ],
  'Taxation': [
    'Corporate',
    'Individual',
    'Shelters',
  ],
  'Intellectual Property': [
    'Patent Related Intellectual Property',
    'Non-Patent Related Intellectual Property',
  ]
}

export const subareasOfPractice: { [area: string]: string[] } = {
  'Real Estate': [
    'Commercial',
    'Residential'
  ],
  'General Business - Other Than Real Estate': [
    'Corporate Law/Business Organization',
    'Business Transactions - Contracts',
    'Financial Institution Representation'
  ],

  'Plaintiff Representation': [
    'Bodily Injury Or Personal Injury',
    'Mass/Group Tort, Class Action'
  ],
  'Other Plaintiff Representation': [
    'Persons Seeking Other Affirmative Relief Under Civil Law',
    'Workers’ Compensation',
    'Medical Malpractice',
    'Employment/Labor Law'
  ],
  'Defense': [
    'Insurance Defense',
    'Commercial Litigation Defense',
    'Criminal'
  ],
  'Intellectual Property': [
    'Patent Related Intellectual Property',
    'Non-Patent Related Intellectual Property'
  ]
}

// Provide a mapping from desc -> ISI code. 
// To accomodate for some slight differences between how TLIE and ISI represent Real Estate descriptions,
// both versions are included and mapped to the same code here in the 'Real Estate' group. 
// The other groups have descriptions common to both TLIE and ISI.

export const flatAreasOfPracticeOld = [
  { group: 'Real Estate', desc: 'Commercial', code: 'RC' },
  { group: 'Real Estate', desc: 'Commercial Real Estate', code: 'RC' },
  { group: 'Real Estate', desc: 'Residential', code: 'RR' },
  { group: 'Real Estate', desc: 'Residential Real Estate', code: 'RR' },
  { group: 'Real Estate', desc: 'Foreclosure', code: 'RF' },
  { group: 'Real Estate', desc: 'Foreclosure on Real Estate', code: 'RF' },
  { group: 'Real Estate', desc: 'Another kind of real estate', code: 'RO' },
  { group: 'Real Estate', desc: 'Real Estate - Other', code: 'RO' },

  //provide codes for some top-level areas which don't define "types" in the UI
  { group: 'Oil & Gas', desc: 'Oil & Gas', code: 'OO' },
  { group: 'Administrative', desc: 'Administrative', code: 'OA' },
  { group: 'Immigration', desc: 'Immigration', code: 'OI' },
  { group: 'Environmental', desc: 'Environmental', code: 'OE' },
  { group: 'Other', desc: 'Other', code: 'OT' },

  { group: 'General Business', desc: 'Collections, Bankruptcy, Other Debt', code: 'GC' },
  { group: 'General Business', desc: 'Business Organization Matters', code: 'GO' },
  { group: 'General Business', desc: 'Business Transactions - Contracts', code: 'GT' },
  { group: 'General Business', desc: 'General Business/Corporate Advice', code: 'GG' },
  { group: 'General Business', desc: 'Financial Institution Representation', code: 'GF' },
  { group: 'Fiduciary', desc: 'ERISA', code: 'FE' },
  { group: 'Fiduciary', desc: 'Employee Benefits', code: 'FB' },
  { group: 'Fiduciary', desc: 'Attorney/Guardian Ad Litem', code: 'FA' },

  { group: 'Securities Law', desc: 'Public Offering Securities', code: 'SP' },
  { group: 'Securities Law', desc: 'Private Placement of Securities', code: 'SV' },
  { group: 'Securities Law', desc: 'Oil and Gas Syndications', code: 'SG' },
  { group: 'Securities Law', desc: 'Real Estate Syndications', code: 'SR' },
  { group: 'Securities Law', desc: 'Municipal Bonds - Tax Exempt - Reviewed by Attorney General', code: 'SB' },
  { group: 'Securities Law', desc: 'Municipal Bonds - Taxable', code: 'ST' },
  { group: 'Securities Law', desc: 'Limited Partnerships', code: 'SL' },
  { group: 'Securities Law', desc: 'Joint Ventures (uses of contemplates using private investor funds)', code: 'SJ' },
  { group: 'Securities Law', desc: 'Other Types of Securities Practice', code: 'SO' },
  
  { group: 'Estate, Trust, and Probate', desc: 'Estate Administration', code: 'EA' },
  { group: 'Estate, Trust, and Probate', desc: 'Estate Planning', code: 'EP' },
  { group: 'Estate, Trust, and Probate', desc: 'Trust Administration', code: 'ET' },
  { group: 'Estate, Trust, and Probate', desc: 'Drafting of Wills', code: 'EW' },
  { group: 'Estate, Trust, and Probate', desc: 'Probate', code: 'EB' },
  { group: 'Estate, Trust, and Probate', desc: 'Guardianship', code: 'EG' },

  { group: 'Family', desc: 'Domestic Relations - Including Divorce', code: 'FD' },
  { group: 'Family', desc: 'Juvenile Proceedings', code: 'FJ' },
  { group: 'Family', desc: 'Adoption Services', code: 'FS' },

  { group: 'Plaintiff Representation', desc: 'Bodily Injury or Personal Injury', code: 'PB' },
  { group: 'Plaintiff Representation', desc: 'Workers’ Compensation', code: 'PW' },
  { group: 'Plaintiff Representation', desc: 'Medical Malpractice', code: 'PM' },
  { group: 'Plaintiff Representation', desc: 'Mass/Group Tort, Class Action', code: 'PT' },

  { group: 'Other Plaintiff Representation', desc: 'Persons Seeking Other Affirmative Relief Under Civil Law', code: 'PP' },
  { group: 'Other Plaintiff Representation', desc: 'Commercial Litigation', code: 'PC' },
  
  { group: 'Defense', desc: 'Insurance Defense', code: 'DI' },
  { group: 'Defense', desc: 'Commercial Litigation Defense', code: 'DL' },
  { group: 'Defense', desc: 'Criminal Defense', code: 'DC' },
  
  { group: 'Taxation', desc: 'Corporate', code: 'TC' },
  { group: 'Taxation', desc: 'Individual', code: 'TI' },
  { group: 'Taxation', desc: 'Shelters', code: 'TS' },
  
  { group: 'Intellectual Property', desc: 'Patent Related Intellectual Property', code: 'IP' },
  { group: 'Intellectual Property', desc: 'Non-Patent Related Intellectual Property', code: 'IN' }
  ];

export const flatAreasOfPractice = [
  { group: 'Real Estate', desc: 'Commercial', code: 'RC' },
  { group: 'Real Estate', desc: 'Residential', code: 'RR' },

  //provide codes for some top-level areas which don't define "types" in the UI
  { group: 'Bankruptcy', desc: 'Bankruptcy', code: 'BR' },
  { group: 'Collections', desc: 'Collections', code: 'CO' },
  { group: 'Securities Municipal Bonds - Tax Exempt', desc: 'Securities Municipal Bonds - Tax Exempt', code: 'SB' },
  { group: 'Securities - Other Types Of Securities Practice', desc: 'Securities - Other Types Of Securities Practice', code: 'SE' },
  { group: 'Family Law (Including Juvenile And Adoption)', desc: 'Family Law (Including Juvenile And Adoption)', code: 'FM' },
  { group: 'Immigration', desc: 'Immigration', code: 'OI' },
  { group: 'Taxation', desc: 'Taxation', code: 'TX' }, 
  { group: 'Oil And Gas (Includes Title Work)', desc: 'Oil And Gas (Includes Title Work)', code: 'OO' },
  { group: 'Administrative', desc: 'Administrative', code: 'OA' },
  { group: 'Mediation/Arbitration', desc: 'Mediation/Arbitration', code: 'OM' },
  { group: 'Other', desc: 'Other', code: 'OT' },
  { group: 'Environmental', desc: 'Environmental', code: 'OE' },
  { group: 'Estate, Trust And Probate Law (Including Wills And Fiduciary)', desc: 'Estate, Trust And Probate Law (Including Wills And Fiduciary)', code: 'ES' },

  { group: 'General Business - Other Than Real Estate', desc: 'Corporate Law/Business Organization', code: 'GO' },
  { group: 'General Business - Other Than Real Estate', desc: 'Business Transactions - Contracts', code: 'GT' },
  { group: 'General Business - Other Than Real Estate', desc: 'Financial Institution Representation', code: 'GF' },
  
  { group: 'Plaintiff Representation', desc: 'Bodily Injury Or Personal Injury', code: 'PB' },
  { group: 'Plaintiff Representation', desc: 'Mass/Group Tort, Class Action', code: 'PT' },
  
  { group: 'Other Plaintiff Representation', desc: 'Persons Seeking Other Affirmative Relief Under Civil Law', code: 'PP' },
  { group: 'Other Plaintiff Representation', desc: 'Workers’ Compensation', code: 'PW' },
  { group: 'Other Plaintiff Representation', desc: 'Medical Malpractice', code: 'PM' },
  { group: 'Other Plaintiff Representation', desc: 'Employment/Labor Law', code: 'LL' },

  { group: 'Defense', desc: 'Insurance Defense', code: 'DI' },
  { group: 'Defense', desc: 'Commercial Litigation Defense', code: 'DL' },
  { group: 'Defense', desc: 'Criminal', code: 'DC' },

  { group: 'Intellectual Property', desc: 'Patent Related Intellectual Property', code: 'IP' },
  { group: 'Intellectual Property', desc: 'Non-Patent Related Intellectual Property', code: 'IN' }
  ];


  export function lookupAOPCode(desc: any) {
    if (!desc) { return ""; }
    if (desc.match(/Residential/i)) { return "RR"; }
    if (desc.match(/Foreclosure/i)) { return "RF"; }
    if (desc.match(/Another kind of real estate/i)) { return "RO"; }
    if (desc.match(/Real estate - Other/i)) { return "RO"; }
    // let hit = flatAreasOfPractice.find(o => {
    //   if (o.desc && o.desc === desc) { return true; }
    //   return false;
    // });

    let hit = flatAreasOfPractice.find(o => o.desc?.toLocaleUpperCase() === desc.toLocaleUpperCase());

    if (hit) { 
      return hit.code 
    }
    return "";
  }






export const aboutAttorneyPosition = [
  'Associate or Employed Attorney',
  'Independent Contract Attorney',
  'Member of PLLC',
  'Officer or Shareholder of PC',
  'Of Counsel',
  'Partner',
  'Sole Proprietor',
]

export const aboutAttorneyPrivatePractice = Array.from({ length: 100 }, (_, i) => {
  return `${i} Year${i !== 1 ? 's' : ''}`;
});


export const previousLiabilityLimits = [
  '100,000 per claim / 300,000 aggregate',
  '250,000 per claim / 500,000 aggregate',
  '500,000 per claim / 500,000 aggregate',
  '500,000 per claim / 1M aggregate',
  '1M per claim / 1M aggregate',
  'Other',
]

export const previousLiabilityDeductibles: number[] = [
  1000, 3000, 5000, 10000, 25000, 50000, 100000
]

export const policyTypesCoverage = [
  {
    coverageName: 'Underwritting Criteria',
    premier: { isIncluded: true, 
      label: 'Offered to firms that meet TLIE’s standard underwriting criteria.' },
    essential: { isIncluded: true, 
      label: 'Only available with excellent claim history.\n' +
          '\n' +
          'Discounted rates may be available for new lawyers (licensed less than 4 years), part-time lawyers and for referral service work only.\n' }
  },
  {
    coverageName: 'Limits of Liability',
    premier: { isIncluded: true,
      label: 'Available with limits of liability from\n' +
          '$100,000 to $10,000,000+\n' },
    essential: { isIncluded: true,
      label: 'Available with 4 different limits of liability:\n' +
      '$100,000 per claim/$300,000 aggregate:\n' +
      '$200,000 per claim/$600,000 aggregate:\n' +
      '$500,000 per claim/$500,000 aggregate:\n' +
      '$1,000,000 per claim/$1,000,000 aggregate:\n' }
  },
  {
    coverageName: 'Deductibles',
    premier: { isIncluded: true,
      label: 'Vary based on the limit of liability and insured’s qualifications. Applies to loss payments and defense costs.' },
    essential: { isIncluded: true,
      label: '$1,000 deductible per policy year. Applies only to loss payments.' }
  },
  {
    coverageName: 'Expense Allowance',
    premier: { isIncluded: true,
      label: 'Additional $50,000 for defense costs (for policies with limits up to $1 million.)' },
    essential: { isIncluded: true,
      label: 'Defense costs included in policy limit.' }
  },
  {
    coverageName: 'Prior Acts Coverage',
    premier: { isIncluded: true,
      label: 'In general, legal services covered since Retroactive Date (based on insured’s coverage history.) Subject to change based on insured’s qualifications and/or special circumstances.' },
    essential: { isIncluded: true,
      label: 'Generally limited to 2 years.' }
  },
  {
    coverageName: 'Grievance Defense',
    premier: { isIncluded: true,
      label: 'Up to $25,000 for defending each disciplinary action, with a maximum of\n' +
          '$50,000 per Policy Period.\n' },
    essential: { isIncluded: true,
      label: 'Up to $5,000 for defending each disciplinary action, with a maximum of\n' +
          '$5,000 per Policy Period.\n' }
  },
  {
    coverageName: 'Subpoena Defense',
    premier: { isIncluded: true,
      label: 'Up to $15,000 per occurrence, with a maximum of $25,000 per policy period.\n' +
          'No deductible is applicable.' },
    essential: { isIncluded: true,
      label: 'Up to $5,000 per occurrence, with a maximum of $5,000 per policy period.\n' +
          'No deductible is applicable.' }
  },
  {
    coverageName: 'Securities Work',
    premier: { isIncluded: true,
      label: 'Coverage provided for securities-related legal work.' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'Punitive Damages',
    premier: { isIncluded: true,
      label: 'If actual damages are covered, then punitive, exemplary and mental anguish damages\n' +
          'are covered.\n' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'DTPA Damages',
    premier: { isIncluded: true,
      label: 'If actual damages are covered, then additional DTPA damages are covered.' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'Cyber-Related Incident',
    premier: { isIncluded: true,
      label: 'Third-party Cyber Related Incident Coverage at sublimits in excess of the policy deductible of the lesser of 10% of policy limit or $100,000.' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'Directors & Officers (D&O) Coverage',
    premier: { isIncluded: true,
      label: 'Coverage with sublimits of the lesser of 10% of policy limit or $25,000.\n' +
          'No deductible is applicable.\n' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'Crisis Event Coverage',
    premier: { isIncluded: true,
      label: 'Coverage with sublimits the lesser of 10% of policy limit or $25,000. No deductible is applicable.' },
    essential: { isIncluded: true,
      label: 'Not covered.' }
  },
  {
    coverageName: 'Zero-Cost Extended Reporting Period (tail)',
    premier: { isIncluded: true,
      label: 'Available to attorneys who are retired, disabled and unable to practice, or deceased – limited to a one-year term, at limits of\n' +
          '$100,000/$300,000.\n' +
          'Must be continuously insured with TLIE for five or more years. The ERP is not renewable.\n' },
    essential: { isIncluded: true,
      label: 'Benefit not available.' }
  },
  {
    coverageName: 'Deductible Reduction Benefit',
    premier: { isIncluded: true,
      label: 'Various deductible reduction provisions – See Premier policy benefits for more details.' },
    essential: { isIncluded: true,
      label: 'Benefit not available.' }
  },
  {
    coverageName: 'Loss Prevention Benefit',
    premier: { isIncluded: true,
      label: 'At TLIE’s discretion, an insured may receive reimbursement of reasonable expenses (not applicable to indemnity or settlement payments) incurred (up to $1,000 per instance and $2,500 per policy period) to resolve a dispute with a client, former client, or opposing counsel,\n' +
          'when no claim has been asserted, but if left unresolved, might result in a claim.\n' },
    essential: { isIncluded: true,
      label: 'Benefit not available.' }
  },
]

export const claimTypes = [
  'Claim',
  'Potential claim or incident',
  'In suit',
  'I’m not sure'
]

export const regularPolicyDeductibles = [
  '1k',
  '3k',
  '5k',
  '10k',
  '25k or greater'
]

export type PolicyLimitsLiabilityType = {
  perClaim: number;
  aggregate: number;
  deductibleOptions: number;
}

export type LiabilityLimitsPoliciesType = {
  REGULAR: PolicyLimitsLiabilityType[];
  BASIC: PolicyLimitsLiabilityType[];
}

export const liabilityLimitsPolicies: LiabilityLimitsPoliciesType = {
  REGULAR: [
    { perClaim: 100000, aggregate: 100000, deductibleOptions: 4 },
    { perClaim: 100000, aggregate: 300000, deductibleOptions: 4 },
    { perClaim: 200000, aggregate: 600000, deductibleOptions: 4 },
    { perClaim: 500000, aggregate: 500000, deductibleOptions: 5 },
    { perClaim: 500000, aggregate: 1000000, deductibleOptions: 5 },
    { perClaim: 1000000, aggregate: 1000000, deductibleOptions: 5 },
    { perClaim: 2000000, aggregate: 2000000, deductibleOptions: 5 },
    { perClaim: 3000000, aggregate: 3000000, deductibleOptions: 5 },
    { perClaim: 4000000, aggregate: 4000000, deductibleOptions: 5 },
    { perClaim: 5000000, aggregate: 5000000, deductibleOptions: 5 },
    { perClaim: 5000000, aggregate: 10000000, deductibleOptions: 5 },
    { perClaim: 10000000, aggregate: 10000000, deductibleOptions: 5 },
  ],
  BASIC: [
    { perClaim: 100000, aggregate: 300000, deductibleOptions: 1 },
    { perClaim: 200000, aggregate: 600000, deductibleOptions: 1 },
    { perClaim: 500000, aggregate: 500000, deductibleOptions: 1 },
    { perClaim: 1000000, aggregate: 1000000, deductibleOptions: 1 },
  ]
}

export const policiesFeaturesIncluded = {
  REGULAR: [
    'Claim Expense Allowance',
    'Lost Earnings Provisions',
    'Grievance Allowance',
    'DTPA Coverage',
  ],
  BASIC: [
    'Claim Expense Allowance',
    'Discounts for new, part-time, contract, and referral-service-only lawyers *',
  ]
}

export const workScheduling = [
  'Paper Calendar',
  'Computer Calendar',
  'Discussion with Firm',
  'Mobile Device',
  'Interoffice Memos',
  'Other',
]

export const conflictOfInterestAvoidance = [
  'Memory',
  'Computer',
  'Discussion with Firm',
  'Index Files',
  'Interoffice Memos',
  'Other',
]

export const handleYearsOfPractice =(yrs : any) => {
  if(yrs >= 0 && yrs <=5)
    return'0'
  else if(yrs >= 6 && yrs <=10)
    return'1'
  else if(yrs >= 11 && yrs <=15)
    return'2'
  else if(yrs >= 16 && yrs <=20)
    return'3'
  else if(yrs >= 21)
    return'4'
  else
    return ''
}

export const states =[
  {
      "name": "Alabama",
      "abbreviation": "AL"
  },
  {
      "name": "Alaska",
      "abbreviation": "AK"
  },
  {
      "name": "American Samoa",
      "abbreviation": "AS"
  },
  {
      "name": "Arizona",
      "abbreviation": "AZ"
  },
  {
      "name": "Arkansas",
      "abbreviation": "AR"
  },
  {
      "name": "California",
      "abbreviation": "CA"
  },
  {
      "name": "Colorado",
      "abbreviation": "CO"
  },
  {
      "name": "Connecticut",
      "abbreviation": "CT"
  },
  {
      "name": "Delaware",
      "abbreviation": "DE"
  },
  {
      "name": "District Of Columbia",
      "abbreviation": "DC"
  },
  {
      "name": "Federated States Of Micronesia",
      "abbreviation": "FM"
  },
  {
      "name": "Florida",
      "abbreviation": "FL"
  },
  {
      "name": "Georgia",
      "abbreviation": "GA"
  },
  {
      "name": "Guam",
      "abbreviation": "GU"
  },
  {
      "name": "Hawaii",
      "abbreviation": "HI"
  },
  {
      "name": "Idaho",
      "abbreviation": "ID"
  },
  {
      "name": "Illinois",
      "abbreviation": "IL"
  },
  {
      "name": "Indiana",
      "abbreviation": "IN"
  },
  {
      "name": "Iowa",
      "abbreviation": "IA"
  },
  {
      "name": "Kansas",
      "abbreviation": "KS"
  },
  {
      "name": "Kentucky",
      "abbreviation": "KY"
  },
  {
      "name": "Louisiana",
      "abbreviation": "LA"
  },
  {
      "name": "Maine",
      "abbreviation": "ME"
  },
  {
      "name": "Marshall Islands",
      "abbreviation": "MH"
  },
  {
      "name": "Maryland",
      "abbreviation": "MD"
  },
  {
      "name": "Massachusetts",
      "abbreviation": "MA"
  },
  {
      "name": "Michigan",
      "abbreviation": "MI"
  },
  {
      "name": "Minnesota",
      "abbreviation": "MN"
  },
  {
      "name": "Mississippi",
      "abbreviation": "MS"
  },
  {
      "name": "Missouri",
      "abbreviation": "MO"
  },
  {
      "name": "Montana",
      "abbreviation": "MT"
  },
  {
      "name": "Nebraska",
      "abbreviation": "NE"
  },
  {
      "name": "Nevada",
      "abbreviation": "NV"
  },
  {
      "name": "New Hampshire",
      "abbreviation": "NH"
  },
  {
      "name": "New Jersey",
      "abbreviation": "NJ"
  },
  {
      "name": "New Mexico",
      "abbreviation": "NM"
  },
  {
      "name": "New York",
      "abbreviation": "NY"
  },
  {
      "name": "North Carolina",
      "abbreviation": "NC"
  },
  {
      "name": "North Dakota",
      "abbreviation": "ND"
  },
  {
      "name": "Northern Mariana Islands",
      "abbreviation": "MP"
  },
  {
      "name": "Ohio",
      "abbreviation": "OH"
  },
  {
      "name": "Oklahoma",
      "abbreviation": "OK"
  },
  {
      "name": "Oregon",
      "abbreviation": "OR"
  },
  {
      "name": "Palau",
      "abbreviation": "PW"
  },
  {
      "name": "Pennsylvania",
      "abbreviation": "PA"
  },
  {
      "name": "Puerto Rico",
      "abbreviation": "PR"
  },
  {
      "name": "Rhode Island",
      "abbreviation": "RI"
  },
  {
      "name": "South Carolina",
      "abbreviation": "SC"
  },
  {
      "name": "South Dakota",
      "abbreviation": "SD"
  },
  {
      "name": "Tennessee",
      "abbreviation": "TN"
  },
  {
      "name": "Texas",
      "abbreviation": "TX"
  },
  {
      "name": "Utah",
      "abbreviation": "UT"
  },
  {
      "name": "Vermont",
      "abbreviation": "VT"
  },
  {
      "name": "Virgin Islands",
      "abbreviation": "VI"
  },
  {
      "name": "Virginia",
      "abbreviation": "VA"
  },
  {
      "name": "Washington",
      "abbreviation": "WA"
  },
  {
      "name": "West Virginia",
      "abbreviation": "WV"
  },
  {
      "name": "Wisconsin",
      "abbreviation": "WI"
  },
  {
      "name": "Wyoming",
      "abbreviation": "WY"
  }
]